import React, { Component, Fragment } from "react";
import { renderRouterExterno as RouterProvider } from "@common/router/router";
import LocalizationProvider from "@common/components/localization/localizationProvider.component";

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <LocalizationProvider>
        <Fragment>
          <RouterProvider title={"Tributário"} />
        </Fragment>
      </LocalizationProvider>
    );
  }
}

export default App;
